$(function(){

  uploadCrest('');
  uploadCrest('2');

});

function uploadCrest(nmbr) {

  $('#upload' + nmbr).click(function(){

    $('#custom-crest' + nmbr).trigger('click');
 
  });
  
  $('#custom-crest' + nmbr).change(function(){
    
    //Clear family crest search
  	// $('#searchResults'+nmbr+' > .crests-grid').html('');
    // $('#searchResults'+nmbr+' > .not-found').html('');
    
    var reader = new FileReader();
    reader.onload = function (e) {
      // $('.cont-img').css({"display":"block"});
      // // get loaded data and render thumbnail.
      $('.upload-preview' + nmbr).attr('src', e.target.result);
      document.getElementsByClassName('search-result' + nmbr)[0].classList.remove("svg_hidden");
      document.getElementsByClassName('search-result' + nmbr)[0].classList.add("show");
      document.getElementsByClassName('search-result' + nmbr)[0].innerHTML = `<div class="cont-img"><img src="${e.target.result}" alt="Image"></div>`;
      // document.getElementById("Uimage").src = e.target.result;
      
      $('.upload-preview' + nmbr).fadeIn(300,"swing");
    };
    // read the image file as a data URL.
    reader.readAsDataURL(this.files[0]);
  }); 
}
